import * as libs from "rebass";

const comps = {
  ...libs,
};

export const { Box, Flex, Button, Link, Heading, Text, Image, Card } = comps;
